import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SurveyClosedPreview from './pages/SurveyClosedPreview';
import SurveyClosed from './pages/SurveyClosed';
import SurveyTaken from './pages/SurveyTaken';

const App = () => {
  return (
    <Switch>
      <Route path="/survey-closed/preview/" component={SurveyClosedPreview} />
      <Route path="/survey-closed/" component={SurveyClosed} />
      <Route path="/survey-taken/" component={SurveyTaken} />
    </Switch>
  );
};

export default App;
